/** VWO FME feature key for servicing login experiments (variables include `enableRegistrationV3`). */
export const VWO_FEATURE_SERVICING_LOGIN_V2 = "servicingLoginV2";
